import { Search } from "react-bootstrap-icons";

//App
import useButtonStyles from "./styles";
import { Button } from "../VFX-UI";
import { CSSObject } from "styled-components";

const SearchButton = ({
  style,
  onClickHandler,
}: {
  style?: CSSObject;
  onClickHandler: React.MouseEventHandler<HTMLButtonElement>;
}) => {
  const buttonsStyles = useButtonStyles();
  return (
    <Button
      style={{ ...buttonsStyles.searchButton, ...style }}
      onClick={onClickHandler}
    >
      <Search  style={buttonsStyles.searchIcon} />
    </Button>
  );
};

export default SearchButton;
